import { Grid, TextInput } from "@mantine/core"
import { ActionIcon, Select } from "@tfg/ui"

interface FilterLineProps {
  filter: {
    [key: string]: {
      [type: string]: string
    }
  }
  setFilter: (filter: {
    [key: string]: {
      [type: string]: string
    }
  }) => void
  removeFilter: () => void
}

export const FilterLine = ({
  filter,
  setFilter,
  removeFilter,
}: FilterLineProps) => {
  const FilterKeyOptions = ["name", "brand", "brandReference"].map((key) => ({
    value: key,
    label: key,
  }))
  const key = Object.keys(filter)[0] ?? ""
  const type = filter[key] ? (Object.keys(filter[key])[0] ?? "") : ""
  const value = filter[key] && filter[key][type] ? filter[key][type] : ""

  return (
    <Grid align="flex-end" justify="space-between">
      <Grid.Col span={4}>
        <Select
          data={FilterKeyOptions}
          label="Filter key"
          placeholder="Filter key"
          value={key}
          onChange={(input) => {
            setFilter({
              [input ?? ""]: {
                [type]: value,
              },
            })
          }}
          required
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <Select
          data={[
            { value: "equals", label: "Equals" },
            { value: "contains", label: "Contains" },
            { value: "startsWith", label: "Starts with" },
            { value: "endsWith", label: "Ends with" },
          ]}
          label="Filter type"
          placeholder="Filter type"
          value={type}
          onChange={(input) => {
            setFilter({
              [key]: {
                [input ?? ""]: value,
              },
            })
          }}
          required
        />
      </Grid.Col>
      <Grid.Col span={4}>
        <TextInput
          label="Filter value"
          placeholder="Filter value"
          required
          value={value}
          onChange={(event) => {
            setFilter({
              [key]: {
                [type]: event.currentTarget.value,
              },
            })
          }}
        />
      </Grid.Col>
      <Grid.Col span={1}>
        <ActionIcon
          type="delete"
          onClick={() => {
            removeFilter()
          }}
        />
      </Grid.Col>
    </Grid>
  )
}
